import React from 'react';
import { cva } from 'class-variance-authority';
import { forwardRef, useState } from 'react';
import ErrorMessage from '@/components/common/ErrorMessage';
import { cn } from '@/lib/utils';

const inputSuffixVariants = cva('flex items-center w-full rounded-lg border px-4 border-[#D9DBE9] text-secondary outline-0 disabled:cursor-not-allowed disabled:opacity-50 gap-2', {
    variants: {
        variant: {
            default: '',
            outline: '',
        },
        size: {
            default: 'h-12 px-4 text-base',
            sm: 'h-10 rounded-md px-4 text-sm',
            lg: 'h-11 rounded-md px-4 text-base',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

const InputSuffix = forwardRef(
    (
        {
            suffixText,
            className,
            groupClassName,
            size,
            variant,
            type,
            icon,
            iconClassName,
            inputClassName,
            labelClassName,
            labelStyleClassName,
            labelText,
            id,
            errorType,
            errorData,
            customMessage,
            ...props
        },
        ref
    ) => {
        return (
            <div className={cn('form-input-item', groupClassName)}>
                {labelText && (
                    <label htmlFor={id} className={cn(labelStyleClassName ? labelStyleClassName : 'text-sm capitalize mb-1 text-heading inline-block', labelClassName)}>
                        {labelText}
                    </label>
                )}
                <div className={cn(inputSuffixVariants({ size, className, variant }))}>
                    <button type="button" className={cn('text-base', iconClassName)}>
                        {suffixText && suffixText != '' ? suffixText : ''}
                    </button>
                    <input type={'text'} id={id} ref={ref} className={cn('outline-0 bg-transparent border-0 w-full h-full', inputClassName)} {...props} />
                </div>
                {errorType && <ErrorMessage errorType={errorType} errorData={errorData} customMessage={customMessage} />}
            </div>
        );
    }
);

export { InputSuffix };
